import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var Spinner = require("components/utility/Spinner");
var BraveCheckbox = require("components/utility/BraveCheckbox");

var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");
var CurrentUser = require("lib/account/CurrentUser");

require("data/exports/expandable_student_list_selector.scss");

function getSchoolOrgID(props) {
    var { currentAdmin, persistentData } = props

    if (persistentData.selectedSchoolOrg) {
        var schoolOrgId = [parseInt(persistentData.selectedSchoolOrg.id)]
    } else {
        var schoolOrgId = [parseInt(currentAdmin.org_ids.school_orgs.primary)]
    }
    return schoolOrgId
}

@connect(
    (state, props) => ({
        schoolOrg: RosterSelectors.schoolOrg({ state, id: getSchoolOrgID(props) }),
        loading: RosterSelectors.isLoadingSchoolOrgs({ state, key: 'index' })
    }),
    (dispatch, props) => ({
        // extract teachers for each school org
        populateData: () => {
            return Promise.all([dispatch(RosterActions.fetchSchoolOrgs({
                filters: { ids: getSchoolOrgID(props) },
                embeds: ['school_org.teachers'],
                cache: true
            }))])
        }
    })
)

@providePopulateData()
class TeacherSelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTeachers: props.persistentData.selectedTeachers || [],
            allTeachersSelected: false
        };
    
    }

    ///// HELPERS /////
    
    // returns if all teachers are selected
    allTeachersSelected() {
        var { schoolOrg } = this.props;
        var { selectedTeachers } = this.state;

        return schoolOrg && _.size(schoolOrg.teachers) == _.size(selectedTeachers)
    }

    ///// VALIDATORS /////
    validSelectedTeachers() {
        return !_.isEmpty(this.state.selectedTeachers)
    }

    ///// HANDLERS /////
    handleTeacherSelect(id) {
        var { selectedTeachers } = this.state;

        if (selectedTeachers.includes(id)) {
            selectedTeachers.splice(selectedTeachers.indexOf(id), 1);
        } else {
            selectedTeachers.push(id);
        }

        this.setState({ selectedTeachers, allTeachersSelected: this.allTeachersSelected() });
    }

    handleAllTeacherSelect() {
        var { schoolOrg } = this.props;
        var { allTeachersSelected } = this.state;

        if (allTeachersSelected) {
            var selectedTeachers = []
            var allTeachersSelected = false
        } else {
            var selectedTeachers = _.pluck(schoolOrg.teachers, 'id')
            var allTeachersSelected = true
        }

        this.setState({ selectedTeachers, allTeachersSelected });
    }

    handleRetreatStage() {
        var { selectedStudents, selectedTeachers } = this.state
        this.props.onRetreat({ selectedStudents, selectedTeachers })
    }

    ///// SUBMIT /////
    onSubmit() {
        var { selectedTeachers } = this.state

        var errorMessage = "Please Select A Teacher Before Continuing"

        if (!this.validSelectedTeachers()) {
            this.renderErrorAlert(errorMessage)
        } else {
            this.props.onComplete({ selectedTeachers })
        }
    }

    ///// RENDER METHODS /////

    render() {
        var { schoolOrg } = this.props;
        var { selectedTeachers, allTeachersSelected } = this.state;

        if (this.props.loading) {
            return <Spinner placeholder={true} scale={1.7} />
        }

        return (
            <div className="slDropdownSelectorContainer">
                <div className="dropdownSelector">
                    <div className="dropdownSelector__dropdown">
                        <div className="dropdownSelector__slName">
                            <BraveCheckbox className="dropdownSelector__slNameCheckbox"
                                onClick={() => this.handleAllTeacherSelect()}
                                value={allTeachersSelected} />
                            <div className='slNameContainer'>
                                <span className="boldBlue">Select All</span>
                            </div>
                        </div>
                        {schoolOrg.teachers.map((t, i) => (
                            <div key={i} className="dropdownSelector__slName">
                                <BraveCheckbox className="dropdownSelector__slNameCheckbox"
                                    onClick={() => this.handleTeacherSelect(t.id)}
                                    value={selectedTeachers.includes(t.id)} />
                                <div className='slNameContainer'>
                                    <span className="boldBlue">{`${t.first_name} ${t.last_name}`}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="onSubmitContainer">
                    <button className='backBtn' onClick={() => this.handleRetreatStage()}>Back</button>
                    {this.validSelectedTeachers() && (
                        <button className='nextBtn' onClick={() => this.onSubmit()}>Next</button>
                    )}
                </div>
            </div>
        );
    }

    componentDidMount() {
        if (this.allTeachersSelected()) {
            this.setState({ allTeachersSelected: true})
        }
    }
}

TeacherSelector.propTypes = StrictPropTypes({
    endOnboarding: PropTypes.func,
    handleAdvanceStage: PropTypes.func,
    onSubmit: PropTypes.func,
    onComplete: PropTypes.func,
    onRetreat: PropTypes.func,
    track: PropTypes.array,
    persistentData: PropTypes.object,
    currentAdmin: PropTypes.object,
    organizationTypes: PropTypes.array,
    organizationOptions: PropTypes.array,
    handlePrint: PropTypes.func,
});

module.exports = TeacherSelector;


// WEBPACK FOOTER //
// ./modules/components/data/exports/TeacherSelector.js